import React from 'react';

interface RadioButtonProps {
  /** Unique identifier for the radio input */
  id: string;
  /** Name attribute for the radio group */
  name: string;
  /** Value of the radio option */
  value: string;
  /** Whether the radio option is selected */
  checked: boolean;
  /** Callback when the radio option is selected */
  onChange: () => void;
  /** Label text for the radio option */
  label: string;
  /** Optional subtitle text for additional context */
  subtitle?: string;
  onClick?: (checked: boolean) => void;
  justify?: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  id,
  name,
  value,
  checked,
  onChange,
  onClick,
  label,
  subtitle = '',
  justify,
}) => {
  const click = () => {
    if (onClick) {
      onClick(checked)
    }
  }
  let clsName = "flex items-start gap-2 cursor-pointer " + (justify ? justify : "");

  return (
    <label htmlFor={id} className={clsName}>
      {/* Hidden native radio input */}
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onClick={click}
        onChange={onChange}
        className="hidden"
      />

      {/* Custom radio indicator */}
      <div
        className={`
          w-6 h-6
          rounded-full
          border
          flex-shrink-0
          relative
          cursor-pointer
          ${checked ? 'border-primary-500 z-radio-checked' : 'border-gray-400'}
        `}
      ></div>

      {/* Text block */}
      <div className="flex flex-col text-left leading-snug">
        <span className="text-sm font-medium text-white">{label}</span>
        {subtitle && (
          <span className="text-sm text-gray-400">{subtitle}</span>
        )}
      </div>
    </label>
  );
};

export default RadioButton;
